import useDecodeString from '~/hooks/useDecodeString';
import useTopBarStyles from './TopBarJSS';

export type ITopBarPropsModel = {
  header?: string | string[];
  subHeader?: string;
  watermark?: string;
};

const TopBar = ({ header, subHeader, watermark }: ITopBarPropsModel) => {
  const classes = useTopBarStyles();

  const decodedHeader = useDecodeString(header);

  return (
    <div data-watermark={watermark} className={classes.root}>
      <div className={classes.subtitle}>{subHeader}</div>
      {header && (
        <h2 className={classes.header}>{decodeURIComponent(decodedHeader)}</h2>
      )}
    </div>
  );
};
export default TopBar;
